import {getMenu} from "@/components/dashboard/menu/MenuContent";


export const STICKY_NOTE_MENU = [
    {
        id: 's-acc',
        label: 'Sticky Notes',
        icon: "user-alt",
        open:true,
        items:[
            {
                id: 'new-sticky',
                label: "New",
                icon: "sparkles",
                action: async () => { await Rpc.StickyNotes.addPinnedStickyNote(window.innerWidth - 305, 190) },
                permission: null
            },
            {
                id: 'show-all-sticky',
                label: "Show All",
                icon: "square",
                action: async () =>{EventBus.$emit(Events.showOrHideStickyNotesList)},
                permission: null
            },
        ]
    },
];



/**
 * @returns {Menu}
 */
export async function getStickyNoteMenu() {
    return getMenu(STICKY_NOTE_MENU);
}
